import { render, staticRenderFns } from "./ManejoVentaCartera.vue?vue&type=template&id=ab83efea&scoped=true"
import script from "./ManejoVentaCartera.vue?vue&type=script&lang=js"
export * from "./ManejoVentaCartera.vue?vue&type=script&lang=js"
import style0 from "./ManejoVentaCartera.vue?vue&type=style&index=0&id=ab83efea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab83efea",
  null
  
)

export default component.exports